import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import routeConst from './const.js';
import artistProgramsRoute from './artist-programs-route.js';
import artistPrograms2024Route from './artist-programs-2024-route.js';

const routes = [
  {
    path: '',
    name: routeConst.ARTIST_DASHBOARD,
    meta: {
      title: 'nav.dashboard',
    },
    component: () => import(
      /* webpackChunkName: "artist-dashboard" */
      '@/views/contributor/dashboard/Dashboard.vue'
    ),
  },
  {
    path: 'price-templates',
    name: routeConst.ARTIST_PRICE_TEMPLATE_LIST,
    meta: {
      title: 'nav.price_templates',
    },
    component: () => import(
      /* webpackChunkName: "artist-price-templates-list-page" */
      '@/views/artist/price-templates/PriceTemplateList.vue'
    ),
  },
  {
    path: 'price-templates/new',
    name: routeConst.ARTIST_PRICE_TEMPLATE_NEW,
    meta: {
      title: 'nav.price_templates',
    },
    component: () => import(
      /* webpackChunkName: "artist-price-templates-edit-page" */
      '@/views/artist/price-templates/PriceTemplateEdit.vue'
    ),
  },
  {
    path: 'price-templates/edit/:templateId',
    name: routeConst.ARTIST_PRICE_TEMPLATE_EDIT,
    meta: {
      title: 'nav.price_templates',
    },
    component: () => import(
      /* webpackChunkName: "artist-price-templates-edit-page" */
      '@/views/artist/price-templates/PriceTemplateEdit.vue'
    ),
  },
  // metadata templates
  {
    name: 'artist-metadata-templates',
    path: 'metadata-templates',
    component: () => import(
      /* webpackChunkName: "artist-metadata-templates" */
      '@/views/artist/metadata-templates/MetadataTemplates.vue'
    ),
    children: [
      {
        name: 'artist-metadata-templates-list',
        path: '',
        meta: {
          title: 'nav.metadata_templates',
        },
        component: () => import(
          /* webpackChunkName: "artist-metadata-templates-list" */
          '@/views/artist/metadata-templates/MetadataTemplatesList.vue'
        ),
      },
      {
        name: 'artist-metadata-templates-new',
        path: 'new',
        meta: {
          title: 'nav.metadata_templates',
        },
        component: () => import(
          /* webpackChunkName: "artist-metadata-templates-new" */
          '@/views/artist/metadata-templates/MetadataTemplatesNew.vue'
        ),
      },
      {
        name: 'artist-metadata-templates-edit',
        path: ':id',
        meta: {
          title: 'nav.metadata_templates',
        },
        component: () => import(
          /* webpackChunkName: "artist-metadata-templates-edit" */
          '@/views/artist/metadata-templates/MetadataTemplateEdit.vue'
        ),
      },
    ],
  },
  {
    path: 'upload',
    name: routeConst.ARTIST_UPLOAD,
    meta: {
      title: 'nav.upload_element',
    },
    component: () => import(
      /* webpackChunkName: "artist-upload-page" */
      '@/views/contributor/upload/UploadPage.vue'
    ),
  },
  {
    path: 'sales',
    name: routeConst.ARTIST_SALES,
    meta: {
      title: 'nav.sales',
    },
    component: () => import(
      /* webpackChunkName: "artist-sales-page" */
      '@/views/artist/Sales.vue'
    ),
  },
  {
    path: 'payout',
    name: routeConst.ARTIST_PAYOUT,
    meta: {
      title: 'nav.payouts',
    },
    component: () => import(
      /* webpackChunkName: "artist-payouts-list-page" */
      '@/views/artist/payouts/ListPage.vue'
    ),
  },
  {
    path: 'profile',
    name: 'artist-profile',
    meta: {
      title: 'term.profile',
    },
    component: () => import(
      /* webpackChunkName: "artist-profile" */
      '@/views/contributor/profile/ProfilePage.vue'
    ),
  },
  {
    path: 'settings',
    name: routeConst.ARTIST_SETTINGS,
    meta: {
      title: 'nav.settings',
    },
    component: () => import(
      /* webpackChunkName: "artist-settings-page" */
      '@/views/artist/settings/ArtistSettings.vue'
    ),
  },
  {
    path: 'creators',
    name: routeConst.ARTIST_CREATOR_LIST,
    meta: {
      title: 'nav.creators',
    },
    component: () => import(
      /* webpackChunkName: "artist-creators-list-page" */
      '@/views/artist/creator/ListPage.vue'
    ),
  },
  {
    path: 'sales/list',
    name: routeConst.ARTIST_SALES_ON_DEMAND,
    meta: {
      title: 'On-Demand Report',
    },
    component: () => import(
      /* webpackChunkName: "artist-sales-list-od" */
      '@/views/artist/sales/list/OnDemand.vue'
    ),
  },
  {
    path: 'youtube-content-id',
    name: 'youtube-content-id',
    meta: {
      title: 'term.youtube_content_id',
    },
    component: () => import(/* webpackChunkName: "artist-content-id" */ '@/views/artist/content-id/YoutubeContentIdSettings.vue'),
  },
  {
    path: 'release/list',
    redirect: '/artist/releases',
  },
  {
    path: 'releases',
    name: routeConst.ARTIST_RELEASE_LIST,
    meta: {
      title: 'nav.release_forms',
    },
    component: () => import(
      /* webpackChunkName: "artist-releases-list-page" */
      '@/views/artist/release/ListPage.vue'
    ),
  },
  {
    path: 'element/list',
    redirect: '/artist/elements',
  },
  {
    path: 'element/manage',
    redirect: '/artist/elements',
  },
  {
    path: 'elements',
    name: routeConst.ARTIST_ELEMENT_LIST,
    meta: {
      title: 'nav.products',
    },
    component: () => import(
      /* webpackChunkName: "artist-elements-list-page" */
      '@/views/artist/element/ListPage.vue'
    ),
  },
  {
    path: 'elements/failed-uploads',
    name: 'artist-element-list-failed-uploads',
    meta: {
      title: 'nav.products',
    },
    component: () => import(
      /* webpackChunkName: "artist-elements-failed-uploads-list-page" */
      '@/views/artist/element/ListPage.vue'
    ),
  },
  {
    path: 'collection/list',
    redirect: `/${routeConst.CONTRIBUTOR}`,
  },
  {
    path: 'collection/manage',
    redirect: `/${routeConst.CONTRIBUTOR}`,
  },
  {
    path: 'collections',
    redirect: `/${routeConst.CONTRIBUTOR}`,
  },
  {
    path: 'collections/edit/:collectionId',
    redirect: `/${routeConst.CONTRIBUTOR}`,
  },
  {
    path: 'collection/edit/:collectionId',
    redirect: `/${routeConst.CONTRIBUTOR}`,
  },
  {
    path: 'add-ons',
    component: () => import('@/views/artist/add-ons/AddOnsPage.vue'),
    children: [
      {
        path: '',
        name: 'artist-add-ons-list',
        meta: {
          title: 'program.add_ons',
        },
        component: () => import(
          /* webpackChunkName "artist-add-ons-list" */
          '@/views/artist/add-ons/AddOnsList.vue'
        ),
      },
      {
        path: ':addOnId',
        name: 'artist-add-on',
        meta: {
          title: 'program.add_ons',
        },
        component: () => import(
          /* webpackChunkName: "artist-add-on" */
          '@/views/artist/add-ons/AddOn.vue'
        ),
      },
      {
        path: 'ftp/change-password',
        name: 'change-ftp-password',
        meta: {
          title: 'program.add_ons',
        },
        component: () => import(
          /* webpackChunkName: "artist-addons-ftp-change-password" */
          '@/views/artist/programs/ftp/ChangeFtpPassword.vue'
        ),
      },
    ],
  },
  {
    path: 'connect-wise',
    name: 'contributor-connect-wise',
    component: () => import('@motionelements/core/src/components/payouts/wise/ConnectWise.vue'),
  },
];

if (featureFlagMixin.methods.isFeatureEnabled('transitioned_products')) {
  routes.push(artistPrograms2024Route);
} else {
  routes.push(artistProgramsRoute);
}

export default routes;
